import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contrat-card',
  templateUrl: './contrat-card.component.html',
  styleUrls: ['./contrat-card.component.scss']
})
export class ContratCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
